import { useMatches, useNavigate, useParams } from 'react-router-dom'
import {
  StyledForm,
  StepInfo,
  SubInfo,
  Space,
  CloseButton,
  ModalSubText,
  ModalTitle,
  ModalContainerTop,
  ModalContainerBottom,
} from './styles'

import {
  Container,
  FormDivider,
  TextHeaderBox,
  PageTitle,
  PageHeaderBox,
  PageSubtitle,
  ButtonHeaderBox,
  ExceptionContainer,
} from '../../styles/page-styles/styles'

import {
  DashboardhMediumButton,
  DashboardStepCount,
  Modal,
} from 'bd-web-components'
import { closeButtonIcon } from '../../components/Icon/iconsImport'
import { FormikProps, useFormik } from 'formik'
import { ReactElement, useEffect, useState } from 'react'
import Loader from '../../components/Loader'
import * as Yup from 'yup'
import useSWRMutation, { SWRMutationResponse } from 'swr/mutation'
import {
  ConfirmationProps,
  SucessOrFailModal,
} from '../../components/SucessOrFailModal'
import { errorRedirect } from '../../utils/redirect'
import {
  CourtesySectorProps,
  CourtesyTicketsProps,
  useGetProducerPDV,
} from '../../hooks/producer-pdv'
import { SectorSelector } from './components/SectorSector'
import { TicketSelector } from './components/TicketSelector'
import { AmountSelector } from './components/AmountSelector'
import { cpf } from 'cpf-cnpj-validator'
import * as EmailValidator from 'email-validator'
import { UserSelector } from './components/UserSelector'
import { Confirmation } from './components/Confirmation'
import { useCourtesyRequest } from '../../hooks/courtesy-request'
import {
  courtesyDataConstructor,
  CourtesyRequestInitialProps,
  getSelectedTickets,
  payloadConstructor,
  StepInfoData,
  UserDataProps,
} from '../../utils/courtesy-request-utils'
import {
  GRAY_SCALE_09,
  PRIMARY_BLUE_03,
} from 'bd-web-components/src/utils/dash-colors'
import { courtesyDataConstructorProps } from '../../utils/courtesy-request-utils'
import { IconProducer } from '../../components/Icon'
import { Breadcrumb } from '../../components/Breadcrumb'
import { getDashColor } from '../../styles'

const confirmationSettedMsg: ConfirmationProps = {
  customSuccess: {
    title: 'Cortesias enviadas com sucesso!',
    subtitle: '',
  },
  customError: {
    title: 'Erro ao enviar cortesias!',
    subtitle: 'Tente novamente!',
  },
}

export function CourtesyRequest(): ReactElement {
  window.document.title = 'Envio de Cortesias'
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()

  // -----------------------------------------------------------------
  // USEGUARD HERE
  // IS CONTROL BY THE PRODUCER_PDV_DATA
  // -----------------------------------------------------------------

  const [isOpen, setIsOpen] = useState<boolean>(false)
  const [isConfirmationOpen, setIsConfirmationOpen] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean | null>(null)
  const [confirmationMsg, setConfirmationMsg] = useState<ConfirmationProps>(
    confirmationSettedMsg
  )
  const [limit, setLimit] = useState<number>(0)
  const [currentStep, setCurrentStep] = useState<number>(1)
  const [sectors, setSectors] = useState<CourtesySectorProps[] | null>(null)
  const [eventName, setEventName] = useState<string>('')
  const [tickets, setTickets] = useState<CourtesyTicketsProps[] | null>(null)
  const [count, setCounter] = useState<number>(0)
  const [courtesyData, setCourtesyData] = useState<
    courtesyDataConstructorProps[]
  >([])

  const [userData, setUserData] = useState<UserDataProps>({
    success: false,
    data: {
      cpf: '',
      email: '',
      id: 0,
      nome: '',
    },
    dataAsArray: [],
  })

  let matches = useMatches()
  let crumbs = matches
    .filter((match: any) => Boolean(match.handle?.crumb))
    .map((match: any) => {
      return {
        name: match.handle.crumb(match.data),
        path: match.pathname,
      }
    })

  const initial: CourtesyRequestInitialProps = {
    sector_id: '',
    ticket_id: '',
    ticket_amount: 0,
    user_idetifier: '',
    confirmation: false,
    payload: {} as any,
  }

  const useFormikProps: FormikProps<CourtesyRequestInitialProps> =
    useFormik<CourtesyRequestInitialProps>({
      initialValues: initial,
      validateOnBlur: false,
      validateOnMount: false,
      validationSchema: () => {
        if (currentStep === 1) {
          return Yup.object().shape({
            sector_id: Yup.number().required('Selecione um Setor'),
          })
        }
        if (currentStep === 2) {
          return Yup.object().shape({
            ticket_id: Yup.number().required('Selecione um Ingresso'),
          })
        }
        if (currentStep === 3) {
          return Yup.object().shape({
            ticket_amount: Yup.number().required('Selecione uma Quantidade'),
          })
        }
        if (currentStep === 4) {
          return Yup.object().shape({
            user_idetifier: Yup.string()
              .test(
                'cpf-cnpj-validation',
                'Insira o Email ou CPF do usuário',
                (i) => {
                  if (i !== undefined) {
                    if (cpf.isValid(i) || EmailValidator.validate(i)) {
                      return true
                    } else {
                      return false
                    }
                  } else {
                    return false
                  }
                }
              )
              .required('Requerido'),
          })
        }
        if (currentStep === 5) {
          return Yup.object().shape({})
        }
      },
      onSubmit: async (values: CourtesyRequestInitialProps) => {
        if (currentStep === 1) {
          const { sector } = getSelectedTickets(values, sectors as any)
          setTickets(sector?.tickets as any)
          setCurrentStep((s) => s + 1)
        }
        if (currentStep === 2) {
          setCourtesyData(courtesyDataConstructor(values, sectors as any))
          setCurrentStep((s) => s + 1)
        }
        if (currentStep === 3) {
          values.ticket_amount = count
          setCurrentStep((s) => s + 1)
        }
        if (currentStep === 4) setCurrentStep((s) => s + 1)
        if (currentStep === 5) {
          const { ticket } = getSelectedTickets(values, sectors as any)
          const payload = payloadConstructor({
            event: Number(id),
            user: userData.data,
            pdv: producerPDV.pdv.pdv_serial,
            ticket: ticket,
            quantity: values.ticket_amount,
          })
          values.payload = payload
          setIsOpen(true)
        }
      },
    })

  const { useCourtesyRequestFetcher } = useCourtesyRequest({
    ...useFormikProps.values.payload,
  })

  const {
    trigger: courtesyRequestTrigger,
    isMutating,
  }: SWRMutationResponse<any> = useSWRMutation(
    'useCourtesyRequestFetcher',
    useCourtesyRequestFetcher,
    {
      revalidate: false,
    }
  )

  const handleBack = () => {
    if (currentStep === 1) useFormikProps.setFieldValue('sector_id', '')
    if (currentStep === 2) useFormikProps.setFieldValue('ticket_id', '')
    if (currentStep === 3) useFormikProps.setFieldValue('ticket_amount', 0)
    if (currentStep === 4) {
      useFormikProps.setFieldValue('user_idetifier', '')
      setUserData({
        success: false,
        data: {
          cpf: '',
          email: '',
          id: 0,
          nome: '',
        },
        dataAsArray: [],
      })
    }
    setCurrentStep((prevStep) => prevStep - 1)
  }

  const { producerPDV, producerPDVLoading, producerPDVError } =
    useGetProducerPDV(id as string)

  useEffect(() => {
    if (producerPDV !== undefined) {
      const { courtesy, pdv } = producerPDV
      setLimit(pdv.pdv_max)
      setEventName(pdv.event_name)
      const sectors = courtesy.map((sector: CourtesySectorProps) => {
        return {
          sector_id: sector.sector_id,
          sector_name: sector.sector_name,
          event_name: pdv.event_name,
          tickets: sector.tickets,
        }
      })
      setSectors(sectors)
    }
    if (producerPDVError !== undefined) {
      errorRedirect(
        '/error',
        {
          message: 'Não existem cortesias para esse evento',
          tittle: 'Não permitido',
        },
        navigate
      )
    }
  }, [producerPDV, producerPDVLoading, producerPDVError, navigate])

  const handleButtonClick = () => {
    useFormikProps.submitForm()
  }

  const handlerDelete = async (event: any) => {
    try {
      await courtesyRequestTrigger()
      setIsOpen(false)
      setIsConfirmationOpen(true)
      setIsSuccess(true)
    } catch (error: any) {
      const { response } = error
      const { data }: any = response

      if (data.errorCode === 409) {
        setConfirmationMsg({
          customSuccess: confirmationSettedMsg.customSuccess,
          customError: {
            title:
              'O usuário já atingiu o limite para este ingresso neste evento.',
            subtitle: 'Tente novamente!',
          },
        })
      }
      setIsConfirmationOpen(true)
      setIsOpen(false)
      setIsSuccess(false)
    }
  }

  return (
    <>
      <Container>
        <Breadcrumb paths={crumbs} />
        <PageHeaderBox>
          <TextHeaderBox>
            <PageTitle>{`Cortesias | ${eventName}`}</PageTitle>
            <PageSubtitle>
              Envie cortesias exclusivas para este evento.
            </PageSubtitle>
          </TextHeaderBox>
          <ButtonHeaderBox>
            <DashboardhMediumButton
              onClick={() => navigate(`/events/${id}/courtesy/list`)}
              color="#fff"
              background={getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR')}
              height="48px"
              maxWidth="100%"
              variant="contained"
              width="204px"
              borderRadius='100px'
            >
              {'Cortesias Enviadas'}
            </DashboardhMediumButton>
          </ButtonHeaderBox>
        </PageHeaderBox>
        <FormDivider />
        <div
          style={{
            maxWidth: '600px',
            marginBottom: '-20px',
            padding: '0px',
          }}
        >
          <DashboardStepCount
            isMobile={true}
            steps={currentStep}
            quantity={4}
          />
        </div>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
          }}
        >
          <StepInfo>{StepInfoData(currentStep, limit).stepInfo}</StepInfo>
          <SubInfo>{StepInfoData(currentStep, limit).subInfo}</SubInfo>
        </div>
        {true && (
          <>
            <StyledForm onSubmit={useFormikProps.handleSubmit}>
              {currentStep === 1 && !producerPDVLoading && (
                <SectorSelector
                  sectors={sectors}
                  name="sector_id"
                  handleButtonClick={handleButtonClick}
                  useFormikProps={useFormikProps}
                />
              )}
              {currentStep === 1 && producerPDVLoading && (
                <ExceptionContainer height={400} margin={false}>
                  <Loader />
                </ExceptionContainer>
              )}
              {currentStep === 2 && (
                <TicketSelector
                  name="ticket_id"
                  tickets={tickets}
                  rollBack={handleBack}
                  handleButtonClick={handleButtonClick}
                  useFormikProps={useFormikProps}
                />
              )}
              {currentStep === 3 && (
                <AmountSelector
                  name="ticket_amount"
                  count={count}
                  setCounter={setCounter}
                  limit={limit}
                  data={courtesyData}
                  rollBack={handleBack}
                  handleButtonClick={handleButtonClick}
                  useFormikProps={useFormikProps}
                />
              )}
              {currentStep === 4 && (
                <UserSelector
                  name="user_idetifier"
                  setUserData={setUserData}
                  userData={userData}
                  data={courtesyData}
                  rollBack={handleBack}
                  handleButtonClick={handleButtonClick}
                  useFormikProps={useFormikProps}
                />
              )}
              {currentStep === 5 && (
                <Confirmation
                  data={{
                    event_data: [
                      {
                        title: 'Nome',
                        value: producerPDV.pdv.event_name,
                      },
                      {
                        title: 'Data',
                        value: producerPDV.pdv.event_date,
                      },
                    ],
                    user_data: userData,
                    ticket_data: courtesyDataConstructor(
                      useFormikProps.values,
                      sectors as any
                    ),
                  }}
                  rollBack={handleBack}
                  handleButtonClick={handleButtonClick}
                  useFormikProps={useFormikProps}
                />
              )}
            </StyledForm>
          </>
        )}
        <Modal isShowing={isOpen}>
          <ModalContainerTop>
            <div>
              <ModalTitle>Confirma o envio das cortesias?</ModalTitle>
              <ModalSubText>
                Ao clicar em confirmar será realizado o envio das cortesias para
                o cliente selecionado
              </ModalSubText>
            </div>
            <div>
              <CloseButton
                // @ts-ignore
                onClick={() => setIsOpen(false)}
                type="button"
              >
                <IconProducer src={closeButtonIcon} />
              </CloseButton>
            </div>
          </ModalContainerTop>
          <ModalContainerBottom>
            <DashboardhMediumButton
              // @ts-ignore
              onClick={() => setIsOpen(false)}
              height="52px"
              maxWidth="100%"
              variant="outlined"
              width="133px"
              borderRadius='100px'
            >
              {'Cancelar'}
            </DashboardhMediumButton>
            <Space />
            <DashboardhMediumButton
              // @ts-ignore
              onClick={handlerDelete}
              disabled={isMutating as any}
              background={!isMutating ? getDashColor('SECONDARY_BLUE_01', 'SECONDARY_COLOR') : GRAY_SCALE_09}
              color={isMutating ? PRIMARY_BLUE_03 : '#fff'}
              height="52px"
              maxWidth="100%"
              variant={isMutating ? 'disabled' : 'contained'}
              width="100%"
              borderRadius='100px'
            >
              {!isMutating && <>{'Confirmar'}</>}
              {isMutating && <Loader small={true} />}
            </DashboardhMediumButton>
          </ModalContainerBottom>
        </Modal>
        <SucessOrFailModal
          isOpen={isConfirmationOpen}
          isSuccess={isSuccess}
          customSuccess={confirmationMsg.customSuccess}
          customError={confirmationMsg.customError}
          setIsOpen={setIsConfirmationOpen}
          rollBackUrl={`/events/${id}/courtesy`}
        />
      </Container>
    </>
  )
}
